import * as React from "react";

import { Checkbox as Input } from "kanopi-components/Checkbox";

import { WidthContainer } from "../../ChatFlow/WidthContainer";
import { FormControl } from "kanopi-components/Input";

/* eslint-disable react/prop-types */
export function CheckboxInput({ label, title, help, error, ...props }) {
  return (
    <WidthContainer center={false}>
      <FormControl error={error} caption={help} title={title}>
        <Input {...props}>{label}</Input>
      </FormControl>
    </WidthContainer>
  );
}
